import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'price',
    standalone: false
})
export class PipePrice implements PipeTransform {
  transform(value: number): string {
    value = Math.trunc(value);
    // no-break space: keeps the number in one piece in arabic (RTL), where a plain space lets its groups get reversed
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' DA';
  }
}
